import React from "react";
import { Quote } from "lucide-react";
import { Reveal, PageHero } from "../components/Shared";
import Seo from "../components/Seo";

const HERO_IMAGE = "/img/hero-testimonials.webp";

const TESTIMONIALS_ALL = [
  {
    quote: "Global Equine Group provides the complete management service for my racing interests worldwide. I have been nothing but amazed at the dedication they show to their clients. With this team behind me I don't have to worry about anything. Global Equine Group has produced a winning formula.",
    name: "Mr Claudio Pizarro",
    role: "Racehorse Owner & Professional Footballer",
  },
  {
    quote: "Adam Driver provides a service and team that utilizes all aspects of sports medicine, technology and data analysis to produce outstanding results for his clients, both on the racecourse and on the stud farm. The attention to detail, clarity of communication and focused approach is excellent. I cannot recommend the services of Global Equine Group highly enough.",
    name: "Thomas Mueller",
    role: "Professional Footballer and Racehorse Owner/Breeder",
  },
  {
    quote: "Adam has never let myself or my team down, no matter the challenge I have set him. With a global operation such as ours, and the demands that entails, I know that I can depend on Adam and his team, whenever, wherever.",
    name: "Mr Ali Al Mohairi",
    role: "Trainer and Manager for Sheikh Hamdan Bin Mohammed Al Maktoum",
  },
  {
    quote: "Having known Adam and his assistant Becky through Global Equine Group, as an owner, I can confidently say that it would be very hard to find a more competent and utterly trustworthy team. It is clear that, for once, the client comes first!!",
    name: "Mr Philip Ellick",
    role: "Banker and Racehorse Owner",
  },
  {
    quote: "Adam Driver, together with his team at Global Equine Group, provide a refreshing new concept catering to all the needs of patrons wishing to own and breed racehorses, from initial purchase, throughout their racing career and retirement for breeding or sale. Global Equine Group are not only providing the maximum enjoyment of owning thoroughbred horses, but protecting the owner's interests and saving them money.",
    name: "Marco Botti",
    role: "Racehorse Trainer",
  },
  {
    quote: "With over 20 years of experience in the racing industry and his extensive travelling globally, Adam Driver has knowledge and experience in all aspects of the racing and breeding industry from all four corners of the planet. Adam knows how to get things done, the right way and the best way. I have total confidence in Adam and his team to manage my horses in the UK and America, with every purchase to date ending up a winner on the racecourse, I cannot ask for more.",
    name: "Raed El Youssef",
    role: "Entrepreneur and Business Owner",
  },
  {
    quote: "Adam Driver and Global Equine Group have done it all for us over the last several years. From selecting horses at auction to negotiating private sales – from racehorse management to stallion selection, Adam's advice and guidance has been fantastic in every area. Each suggestion is given real thought and every plan is formulated with real care by the Global Equine team. Perhaps more than anything else, Adam's greatest asset is his integrity. Trust is often a hard thing to come by in racing, but you can trust Adam and Global Equine in all facets of the game.",
    name: "Justin Nicholson",
    role: "Founder of Equestricon and Racehorse Owner/Breeder",
  },
];

export default function Testimonials() {
  return (
    <div data-testid="testimonials-page">
      <Seo
        title="Testimonials"
        description="What owners, trainers and breeders say about Global Equine Group — client references from professional footballers, bankers, entrepreneurs and racing professionals worldwide."
        image={HERO_IMAGE}
      />
      <PageHero image={HERO_IMAGE} kicker="What Our Clients Say" title="Testimonials">
        <p className="text-[#b9c9d6] mt-6 max-w-2xl text-lg leading-relaxed">
          From professional footballers to trainers and breeders — hear from the owners who trust
          Global Equine Group with their racing interests worldwide.
        </p>
      </PageHero>

      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 gap-8">
            {TESTIMONIALS_ALL.map((t, i) => (
              <Reveal key={t.name} delay={i % 2} className={i === 0 ? "md:col-span-2" : ""}>
                <figure
                  className={`gee-card h-full flex flex-col p-9 md:p-10 border-t-2 border-[#29abe2]`}
                  style={{ backgroundColor: i === 0 ? "#0f2438" : "#f7fbfd" }}
                  data-testid={`testimonial-card-${i}`}
                >
                  <Quote size={28} className="text-[#29abe2] mb-5" strokeWidth={1.5} />
                  <blockquote
                    className={`font-serif-d italic leading-relaxed flex-1 ${i === 0 ? "text-white text-xl md:text-2xl" : "text-[#33475a] text-[1.05rem]"}`}
                  >
                    “{t.quote}”
                  </blockquote>
                  <figcaption className="mt-7">
                    <p className={`font-medium ${i === 0 ? "text-[#29abe2]" : "text-[#0f2438]"}`}>{t.name}</p>
                    <p className={`text-xs uppercase tracking-[0.15em] mt-1 ${i === 0 ? "text-[#7d94a6]" : "text-[#8aa0b0]"}`}>
                      {t.role}
                    </p>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "#0f2438" }} className="py-20">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12 text-center">
          <Reveal>
            <h2 className="font-serif-d text-white text-3xl md:text-4xl mb-4">
              Join our winning team
            </h2>
            <p className="text-[#7d94a6] mb-8">
              Experience the service our clients can't stop talking about.
            </p>
            <a href="#contact" className="gee-btn" data-testid="testimonials-contact-btn">
              Get In Touch
            </a>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
